import { render } from "./AvatarPopupShell.vue?vue&type=template&id=c58752f6&scoped=true&ts=true"
import script from "./AvatarPopupShell.vue?vue&type=script&lang=ts"
export * from "./AvatarPopupShell.vue?vue&type=script&lang=ts"

import "./AvatarPopupShell.vue?vue&type=style&index=0&id=c58752f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c58752f6"]])

export default __exports__